<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div style="max-width: 1450px;" class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">BID WANTED</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">  
            <div class="flex-container">
                <!-- <div>
                    <span>CUSTOMER</span><br>
                    <span class="data-value">{{holding.customerFirstName}} {{holding.customerLastName}}</span>
                </div> -->
                <div>
                     <span>CUSIP</span><br>
                    <span class="data-value">{{holding.cusipVal}}</span>
                </div>
                <!-- <div>
                    <span>ACCOUNT</span><br>
                    <span class="data-value">{{holding.accountVal}}</span>
                </div> -->
                <div>
                    <span>VALID TIME</span><br>
                    <span class="data-value">{{holding.expireTime ? moment.utc(holding.expireTime).local().format("hh:mm:ss a") : 'N/A'}}</span>
                </div>
                <div>
                    <span>FIRM UNTIL TIME</span><br>
                    <span class="data-value">{{holding.firmUntilDate ? moment.utc(holding.firmUntilDate).local().format("hh:mm:ss a") : 'N/A'}}</span>
                </div>
                <!-- <div>
                    <span>BOUGHT</span><br>
                    <span class="data-value">{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : "N/A"}}</span>
                </div> -->
                <div>
                    <span>SELL QTY</span><br>
                    <span class="data-value">{{holding.sellQuantity}}</span>
                </div>
                <div>
                    <span>COST</span><br>
                    <span class="data-value">{{holding.cost | currency}}</span>
                </div>

            </div>
            <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                      <thead>
                      <tr >
                        <th 
                        scope="col" 
                        class="sort"
                        >ECN</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >QTY</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >PRICE</th>
                         <th 
                        scope="col" 
                        class="sort text-center"
                        >SPREAD</th>
                         <th 
                        scope="col" 
                        class="sort text-center"
                        >P&L</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >STATUS</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >IBP VALID UNTIL / <br> TWD GOOD FOR </th>
                        <th v-if="holding.status != 'BID_ACCEPTED'"
                        scope="col" 
                        class="sort text-right"
                        >ACTION</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="bid in bids" :key="bid.id" >
                        <td class="text-center">
                            <span class="text-success">{{bid.ecn}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{bid.bidQuantity}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{bid.bidPrice}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{(bid.bidPrice - holding.cost ).toFixed(2)}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{((bid.bidPrice - holding.cost).toFixed(2) * holding.sellQuantity * 10).toFixed(2)}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{bid.status}}</span><br>
                        </td>
                        <td>
                            <span>{{bid.validUntill ? moment.utc(bid.validUntill).local().format("hh:mm:ss a") : 'N/A'}}</span>
                        </td>    
                        <td class="text-right" v-if="(role == 'TRADER')  && (holding.status == 'AUTHORIZED' || holding.status == 'WAITING_AUTHORIZATION' || holding.status == 'BID_RECEIVED' || holding.status == 'REJECTED') && bid.highBid">
                           <button @click="acceptBid(bid)" type="button" class="btn btn-primary" >ACCEPT</button>
                        </td>
                        <td class="text-right" v-if="holding.traderCognitoSub == cognitoSub && (role == 'ADMIN')  && (holding.status == 'AUTHORIZED' || holding.status == 'WAITING_AUTHORIZATION' || holding.status == 'BID_RECEIVED' || holding.status == 'REJECTED') && bid.highBid">
                           <button @click="acceptBid(bid)" type="button" class="btn btn-primary" >ACCEPT</button>
                        </td>
                        <td class="text-right" v-if="role == 'OPERATOR' && holding.status == 'AUTHORIZED' && bid.highBid || (role == 'OPERATOR' && bid.highBid && holding.status == 'REJECTED' && holding.latestAuthBidIds && holding.latestAuthBidIds.length ) ">
                           <button @click="acceptBid(bid)" type="button" class="btn btn-primary" >ACCEPT</button>
                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                   <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getBidWantedList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>    
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'viewbidwanted',
    props:['holding','role'],
    components :{
    },
    data() {
        return {
            loading : false,
            currentPage: 1,
            perPage: 20,
            searchValue : "",
            sortColumn: "bidPrice",
            sortOrder:"DESC",
            totalRows : 0,
            bids : [],
            highestBidPrice : null,
            cognitoSub : authService.getUser().cognitoSub,

        }

    },
    methods : {
        getBidWantedList(){
            ///bidwanted/bids-list?bidWantedId=40&page=0&size=10&sortColumn=bidPrice&sortOrder=DESC
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            // let status = this.holding.status == 'BID_ACCEPTED' ? 'ACCEPTED' : 'NEW,REJECTED,HIGH_BID_RECEIVED,FILLED,NEW_ORDER_INITIATED';
            let status = 'ACCEPTED,NEW,REJECTED,HIGH_BID_RECEIVED,FILLED,NEW_ORDER_INITIATED';
            if(this.holding.status == 'SUCCESS' || this.holding.status == 'DELETED' || this.holding.status == 'DAILY_DELETE') status = "NEW,REJECTED,HIGH_BID_RECEIVED,ACCEPTED,FILLED,NEW_ORDER_INITIATED"
            this.$http
            .get(
                config.baseUrlBidSide +
                "/bidwanted/bids-list?page=" +
                this.currentPage +
                "&size=" +
                this.perPage +
                "&sortColumn=" +
                this.sortColumn +
                "&status="+
                status+
                "&sortOrder=" +
                this.sortOrder+
                "&bidWantedId=" +
                this.holding.id,
                auth
            )
            .then(result => {
                this.totalRows = result.data.pageInfo.totalElements;
                this.bids = result.data.content;
                this.highestBidPrice = Math.max(...this.bids.map(item => item.bidPrice));
                this.loading = false;
            }).catch(() => this.loading = false);
        },
        acceptBid(bid){
            var message = "Are you sure you want to accept this bid?";
            this.$confirm(message,"","question").then(() => {
                this.loader = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                let data = {
                    "bidWantedBidId": bid.id,
                    "cognitoSub": authService.getUser().cognitoSub
                }
                this.$http
                .post(config.baseUrlBidSide + "/bidwanted/accept",data,auth)
                .then(() => {
                    this.loading = false; 
                    //this.getBidWantedList();             
                    this.$alert("The bid has been successfully accepted.","","success");
                    this.$emit('close');  
                })
                .catch(() => {
                    this.loading = false;              
                });
            })
        }    
    },
    mounted(){
        console.log(this.role);
        this.getBidWantedList();
    }
};
</script>
<style scoped>
.flex-container{
    display : flex;
    justify-content: space-between;
}
.flex-container > div{
    margin: 10px;
    text-align: left;
    font-weight: 500;

}
.data-value{
    color:rgb(10 139 213);
    font-weight: 500;
}
</style>
